import { DatePicker } from "antd"
import PropTypes from "prop-types"
import React from "react"
import styled, { css } from "styled-components"

// ----------------------------------------------------------------------------

function _AppDatePicker(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------
    const { value, onChange, label, className, error, format, ...pickerProps } =
        props

    let message
    let invalid

    if (typeof error === "string") {
        message = error
        invalid = !!message
    } else {
        message = error?.message
        invalid = error?.invalid
    }
    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <div className={`${className} ${invalid ? "has-error" : ""}`}>
            <label className="input-label">{label}</label>
            <DatePicker
                className="picker"
                value={value}
                onChange={onChange}
                format={format || "DD MMM YYYY"}
                {...pickerProps}
                placeholder=""
            ></DatePicker>
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_AppDatePicker.propTypes = {
    className: PropTypes.string.isRequired,
    value: PropTypes.any,
    onChange: PropTypes.func,
    label: PropTypes.string,
    error: PropTypes.any,
    height: PropTypes.number,
    paddingHorizontal: PropTypes.number,
    borderRadius: PropTypes.number,
    showTime: PropTypes.object,
    format: PropTypes.string,
    hint: PropTypes.string,
}

_AppDatePicker.defaultProps = {
    error: { invalid: false, message: null },
}

// ----------------------------------------------------------------------------

const defaultPadding = 23
const defaultBorderRadius = 8
const AppDatePicker = styled(_AppDatePicker)`
    & {
        position: relative;

        display: flex;
        flex-direction: column;
        border-radius: 6px;

        font-size: 14px;
        max-width: 100%;
        width: 100%;
        background-color: transparent;

        overflow: hidden;

        .input-label {
            font-size: 14px;
            font-family: "Poppins-Bold";
            text-transform: uppercase;
            position: relative;
            bottom: 3px;

            user-select: none;

            ${(props) =>
                props.disabled &&
                css`
                    z-index: 1;
                    color: #d6d6d6;
                    cursor: not-allowed;
                `}
        }
        .picker {
            font-family: "Poppins-Regular";
            border-radius: 6px;
            min-height: 50px;
            height: 50px;
            max-height: 50px;
        }
        .ant-picker {
            font-family: "Poppins-Regular";
            border-radius: 6px;
            min-height: 50px;
            height: 50px;
            max-height: 50px;
            width: 100%;
            border-radius: ${({ borderRadius }) =>
                borderRadius ?? defaultBorderRadius}px;
            border: 1px solid ${(props) => props.theme.colors.inputBorder};
            background: ${({ theme }) => theme.colors.menuBackgroundColor};
            margin-bottom: 0;
            box-shadow: none !important;
            padding-left: ${({ paddingHorizontal }) =>
                paddingHorizontal ?? defaultPadding}px;
            padding-right: ${({ paddingHorizontal }) =>
                paddingHorizontal ?? defaultPadding}px;
        }
    }
`
// ----------------------------------------------------------------------------

export default AppDatePicker
